import { NAV_HREFS } from "../../data/site";
import { useSite } from "../../context/SiteContext";
import { useLang } from "../../i18n/LangContext";
import { Logo, Filigree, useChannels, useLinks } from "./Brand";
import { SocialRow, TrustStrip, Disclaimer } from "./FooterParts";

const CtaBand = ({ onJoin, t, h, LINKS }) => (
  <div className="glass-card relative mx-auto mb-20 max-w-7xl overflow-hidden p-10 md:p-14">
    <div className="streak" />
    <div className="relative flex flex-col gap-8 md:flex-row md:items-center md:justify-between">
      <div>
        <h2 className="font-serif text-3xl font-bold uppercase text-white sm:text-4xl">{t.ctaA} <span className="gold-text">{t.ctaGold}</span></h2>
        <p className="mt-3 text-zinc-400">{t.ctaSub}</p>
      </div>
      <div className="flex flex-wrap gap-3">
        <button onClick={onJoin} data-testid="cta-join-button" className="btn-gold">{h.join}</button>
        <a href={LINKS.login} data-testid="cta-login-button" className="btn-outline">{h.login}</a>
      </div>
    </div>
  </div>
);

export const Footer = ({ onJoin }) => {
  const { t: all } = useLang();
  const CHANNELS = useChannels();
  const LINKS = useLinks();
  const { site } = useSite();
  const t = all.footer;
  const social = { ...(site?.social || {}), whatsapp: LINKS.whatsapp };
  const head = "mb-3 text-[11px] font-semibold uppercase tracking-[0.2em] text-[#D4AF37]";
  const link = "gold-underline w-fit text-sm text-zinc-400 hover:text-white";
  return (
  <footer id="site-footer" className="px-4 pb-28 pt-8 sm:px-6 sm:pb-10 lg:px-8">
    <CtaBand onJoin={onJoin} t={t} h={all.header} LINKS={LINKS} />
    <div className="mx-auto grid max-w-7xl grid-cols-2 gap-x-6 gap-y-10 border-t border-[#D4AF37]/20 py-12 lg:grid-cols-4">
      <div className="col-span-2 lg:col-span-1">
        <Logo />
        <p className="mt-4 max-w-xs text-sm text-zinc-500">{t.about}</p>
      </div>
      <div className="flex flex-col gap-2.5">
        <p className={head}>{t.explore}</p>
        {NAV_HREFS.map((href, i) => <a key={href} href={href} className={link}>{all.nav[i]}</a>)}
        {site?.blog_count > 0 && <a href="/blog" data-testid="footer-blog-link" className={link}>Blog</a>}
      </div>
      <div className="flex flex-col gap-2.5" data-testid="footer-pages">
        <p className={head}>{t.info}</p>
        {(site?.footer_pages || []).map((p) => (
          <a key={p.slug} href={`/p/${p.slug}`} data-testid={`footer-page-${p.slug}`} className={link}>{p.title}</a>
        ))}
      </div>
      <div className="col-span-2 lg:col-span-1">
        <p className={head}>{t.chat}</p>
        <div className="grid grid-cols-3 gap-2 lg:grid-cols-1">
          {CHANNELS.map((c) => (
            <a key={c.key} href={c.href} target="_blank" rel="noreferrer" data-testid={`footer-${c.key}-link`}
              className="flex flex-col items-center gap-1.5 rounded-xl border border-[#D4AF37]/20 py-3 text-xs text-zinc-300 transition-colors hover:border-[#D4AF37] lg:flex-row lg:gap-3 lg:border-0 lg:py-1 lg:text-sm lg:text-zinc-400">
              <c.icon size={18} style={{ color: c.color }} /> {c.label}
            </a>
          ))}
        </div>
      </div>
    </div>
    <div className="mx-auto max-w-7xl space-y-8 border-t border-[#D4AF37]/20 py-10">
      <SocialRow links={social} label={t.follow} />
      <TrustStrip t={t} />
      <Disclaimer t={t} />
      <div className="flex flex-col gap-4 md:flex-row md:items-start" data-testid="responsible-gaming-notice">
        <span className="grid h-12 w-12 shrink-0 place-items-center rounded-full border-2 border-[#D4AF37] font-serif text-base font-bold text-[#D4AF37]">18+</span>
        <p className="text-xs leading-relaxed text-zinc-500">{t.rg}</p>
      </div>
      <div className="flex flex-col items-center gap-3">
        <Filigree />
        <p className="text-xs text-zinc-600">© {new Date().getFullYear()} DaddyAnna247. {t.rights}</p>
      </div>
    </div>
  </footer>
  );
};
